export default __webpack_public_path__ + "static/media/hero-phone.9ab3b43f.png";